import Repository from "./RepositoryFactoryMain";
const ADD_CATEGORY = "add";
const EDIT_CATEGORY = "editCategory";
const GET_CATEGORY = "get";
const GET_DETAILED_CATEGORY = "getDetailedCategory";
const GET_DETAILED_CATEGORYALL = "getDetailedCategoryAll";

export default {
  addCategory(payload) {
    return Repository.post(transformRoute(ADD_CATEGORY), payload);
  },
  editCategory(payload) {
    return Repository.post(transformRoute(EDIT_CATEGORY), payload);
  },
  getCategory() {
    return Repository.post(transformRoute(GET_CATEGORY));
  },
  getDetailedCategory() {
    return Repository.post(transformRoute(GET_DETAILED_CATEGORY));
  },
  getDetailedCategoryAll(payload) {
    return Repository.post(transformRoute(GET_DETAILED_CATEGORYALL), payload);
  },
};

const transformRoute = (route) => {
  return `/ecom/category/${route}`;
};
